import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { IEquipmentTransfer, ITransferHistory } from '@services/registrations/registrations.models';

import { DialogService } from '@services/dialog/';
import { RegistrationsService } from '@services/registrations';

@Component({
	selector: 'app-view-user-details',
	templateUrl: './view-user-details.component.html',
	styleUrls: ['./view-user-details.component.scss']
})
export class ViewUserDetailsComponent implements OnInit {
	userDetails;

	public sentTransferHistory: IEquipmentTransfer[] = [];
	public sentDataReady = false;

	public receivedTransferHistory: IEquipmentTransfer[] = [];
	public receivedDataReady = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public dialogData,
		private dialogRef: MatDialogRef<ViewUserDetailsComponent>,
		private dialogService: DialogService,
		public registrationsService: RegistrationsService
	) { }

	ngOnInit(): void {
		this.prepData(this.dialogData['user']);
		this.loadSentTransfers(this.dialogData['user']['id']);
		this.loadReceivedTransfers(this.dialogData['user']['email']);
	}

	prepData(data) {
		this.userDetails = [
			{ label: 'Id', value:  data['id'] },
			{ label: 'First Name', value: data['firstname'] },
			{ label: 'Last Name', value: data['lastname'] },
			{ label: 'Email', value: data['email'] }
		];
	}

	loadSentTransfers(id: string) {
		this.registrationsService.sentTransfers(id).subscribe((res: IEquipmentTransfer[]) => {
			this.sentTransferHistory = res;
			this.sentDataReady = true;
		});
	}

	loadReceivedTransfers(id: string) {
		this.registrationsService.receivedTransfers(id).subscribe((res: IEquipmentTransfer[]) => {
			this.receivedTransferHistory = res;
			this.receivedDataReady = true;
		});
	}
}
